import {
  BaseballEventStatusId,
  BaseballIncidentId,
} from '@collector/sportsapi-client-legacy'

import { EventStatusIncidentsOnFieldConfig } from '../../configuration'

const eventStatusToIncidentIdMap: Map<
  BaseballEventStatusId,
  BaseballIncidentId[]
> = new Map([
  [
    BaseballEventStatusId.NotStarted,
    [
      BaseballIncidentId.MatchAboutToStart,
      BaseballIncidentId.FirstInningStarted,
    ],
  ],
  [
    BaseballEventStatusId.StartDelayed,
    [
      BaseballIncidentId.MatchAboutToStart,
      BaseballIncidentId.FirstInningStarted,
    ],
  ],
  [
    BaseballEventStatusId.BreakAfterFirstInning,
    [BaseballIncidentId.SecondInningStarted],
  ],
  [
    BaseballEventStatusId.BreakAfterSecondInning,
    [BaseballIncidentId.ThirdInningStarted],
  ],
  [
    BaseballEventStatusId.BreakAfterThirdInning,
    [BaseballIncidentId.FourthInningStarted],
  ],
  [
    BaseballEventStatusId.BreakAfterFourthInning,
    [BaseballIncidentId.FifthInningStarted],
  ],
  [
    BaseballEventStatusId.BreakAfterFifthInning,
    [BaseballIncidentId.SixthInningStarted],
  ],
  [
    BaseballEventStatusId.BreakAfterSixthInning,
    [BaseballIncidentId.SeventhInningStarted],
  ],
  [
    BaseballEventStatusId.BreakAfterSeventhInning,
    [BaseballIncidentId.EighthInningStarted],
  ],
  [
    BaseballEventStatusId.BreakAfterEighthInning,
    [BaseballIncidentId.NinthInningStarted],
  ],
  [
    BaseballEventStatusId.BreakAfterNinthInning,
    [BaseballIncidentId.TenthInningStarted],
  ],
  [
    BaseballEventStatusId.BreakAfterTenthInning,
    [BaseballIncidentId.EleventhInningStarted],
  ],
  [
    BaseballEventStatusId.BreakAfterEleventhInning,
    [BaseballIncidentId.TwelfthInningStarted],
  ],
  [
    BaseballEventStatusId.BreakAfterTwelfthInning,
    [BaseballIncidentId.ThirteenthInningStarted],
  ],
  [
    BaseballEventStatusId.BreakAfterThirteenthInning,
    [BaseballIncidentId.FourteenthInningStarted],
  ],
  [
    BaseballEventStatusId.BreakAfterFourteenthInning,
    [BaseballIncidentId.FifteenthInningStarted],
  ],
  [
    BaseballEventStatusId.BreakAfterFifteenthInning,
    [BaseballIncidentId.SixteenthInningStarted],
  ],
  [
    BaseballEventStatusId.BreakAfterSixteenthInning,
    [BaseballIncidentId.SeventeenthInningStarted],
  ],
  [
    BaseballEventStatusId.BreakAfterSeventeenthInning,
    [BaseballIncidentId.EighteenthInningStarted],
  ],
  [
    BaseballEventStatusId.BreakAfterEighteenthInning,
    [BaseballIncidentId.NineteenthInningStarted],
  ],
  [
    BaseballEventStatusId.BreakAfterNineteenthInning,
    [BaseballIncidentId.TwentiethInningStarted],
  ],
  [
    BaseballEventStatusId.BreakAfterTwentiethInning,
    [BaseballIncidentId.TwentyFirstInningStarted],
  ],
  [
    BaseballEventStatusId.BreakAfterTwentyFirstInning,
    [BaseballIncidentId.TwentySecondInningStarted],
  ],
  [
    BaseballEventStatusId.BreakAfterTwentySecondInning,
    [BaseballIncidentId.TwentyThirdInningStarted],
  ],
])

export const eventStatusIncidentsOnFieldConfig: EventStatusIncidentsOnFieldConfig =
  {
    eventStatusToIncidentIdMap,
  }
